import { createFileRoute, redirect } from '@tanstack/react-router';

import * as DataIngestion from '@mint-sdk/api-data-ingestion';
import { z } from 'zod';

const searchSchema = z.object({
  search: z.string().prefault(''),
});

export const Route = createFileRoute(
  '/_secured/external-data/import-hub/whitelisted-emails',
)({
  staleTime: 30 * 1000,
  validateSearch: searchSchema,
  async beforeLoad({ context }) {
    const hasViewPermission = await context.hasPermission(
      'dataManagementHubFeature:view',
    );
    if (!hasViewPermission) {
      throw redirect({ to: '/' });
    }
  },
  loader: async ({ context, cause }) => {
    if (cause === 'stay') {
      return;
    }

    const queryClient =
      await context.serviceLocator.getOrThrowInstance('queryClient');

    queryClient.prefetchQuery(
      DataIngestion.WhitelistedEmails.getWhitelistedEmailsQueryOptions({}),
    );
  },
});
